/**
 * Hide the static HTML splash screen with a fade-out transition.
 * Returns a promise that resolves once the element has been removed from the DOM.
 */
export function hideSplash(): Promise<void> {
  const el = document.getElementById("splash");
  if (!el) return Promise.resolve();

  // If already hidden, just wait a tick and resolve.
  if (el.classList.contains("hidden")) {
    return new Promise((resolve) => setTimeout(resolve, 0));
  }

  return new Promise((resolve) => {
    el.classList.add("hidden");
    setTimeout(() => {
      el.remove();
      resolve();
    }, 200);
  });
}
